import { api } from '@/lib/api';
import type {
  CreateSavedFilterInput,
  SavedFilter,
  SavedFilterScope,
  UpdateSavedFilterInput,
} from './types';

/**
 * L16 — saved filters REST client.
 *
 * Endpoints (NestJS module `saved-filters`):
 *   GET    /saved-filters?scope=
 *   POST   /saved-filters
 *   PATCH  /saved-filters/:id
 *   DELETE /saved-filters/:id
 */
export const savedFiltersService = {
  async list(scope?: SavedFilterScope): Promise<SavedFilter[]> {
    const { data } = await api.get<SavedFilter[]>('/saved-filters', {
      params: scope ? { scope } : {},
    });
    return data;
  },

  async create(input: CreateSavedFilterInput): Promise<SavedFilter> {
    const { data } = await api.post<SavedFilter>('/saved-filters', input);
    return data;
  },

  async update(
    id: string,
    patch: UpdateSavedFilterInput,
  ): Promise<SavedFilter> {
    const { data } = await api.patch<SavedFilter>(
      `/saved-filters/${id}`,
      patch,
    );
    return data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/saved-filters/${id}`);
  },
};
